import { gql, useLazyQuery } from "@apollo/client";

const GET_ALL_ADMIN_USERS_QUERY = gql`
  query GetAllAdminUsers {
    getAllAdminUsers {
      _id
      firstName
      lastName
      email
      role
      permissions
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const useGetAllAdminUsersQuery = () => {
  const [getAllAdminUsersQuery, { loading, error, data }] = useLazyQuery(
    GET_ALL_ADMIN_USERS_QUERY
  );

  const getAllAdminUsers = async (refresh: boolean = false) => {
    console.log("🔍 Executing GraphQL query: getAllAdminUsers");
    try {
      const result = await getAllAdminUsersQuery({
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      console.log("📊 GraphQL result:", result);
      console.log("📊 GraphQL data:", result.data);
      console.log("📊 GraphQL errors:", result.errors);
      return result.data?.getAllAdminUsers ?? [];
    } catch (error) {
      console.error("❌ GraphQL query failed:", error);
      throw error;
    }
  };

  return {
    getAllAdminUsers,
    loading,
    error,
    data,
  };
};






























